module.exports = __webpack_public_path__ + "static/img/order_management.0d57856b.png";